import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFilter = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 21,
	viewBox: "0 0 20 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M18.75 0C19.1016 0 19.4141 0.15625 19.6484 0.390625C19.8828 0.625 20 0.9375 20 1.25C20 1.60156 19.8828 1.91406 19.6484 2.14844L12.5 9.25781V18.75C12.5 19.1016 12.3828 19.375 12.1484 19.6094C11.9141 19.8438 11.6016 20 11.2891 20C10.9766 20.0391 10.6641 19.9219 10.4297 19.6875L7.92969 17.5C7.61719 17.2656 7.5 16.9531 7.5 16.5625V9.25781L0.351562 2.14844C0.117188 1.91406 0 1.60156 0 1.25C0 0.9375 0.117188 0.625 0.351562 0.390625C0.585938 0.15625 0.859375 0 1.25 0H18.75ZM11.25 8.75L18.75 1.25H1.25L8.75 8.75V16.5625L11.25 18.75V8.75Z",
		fill: "currentColor"
	})
});
export default SvgFilter;
